module.exports = __webpack_public_path__ + "static/media/foto3.3966de02.png";